import { __rest } from "tslib";
import React from 'react';
import { BtwText } from './BtwText';
function BtwHeading(props) {
    const { weight = 'semibold', variant = 'primary' } = props, rest = __rest(props, ["weight", "variant"]);
    return React.createElement(BtwText, Object.assign({ variant: variant, weight: weight }, rest));
}
export { BtwHeading };
